import { styled } from '@mui/material';

import {
    Avatar,
    Checkbox,
    IconButton,
    ScrollableTable,
    ScrollableTableBody,
    ScrollableTableCell,
    ScrollableTableHead,
    ScrollableTableRow,
    Stack,
    Text,
} from 'shell/components';

const data = [
    {
        name: 'Very Very Very Long Filename.pdf',
        type: 'PDF',
        uploaded_by: (
            <Stack alignItems={'center'} direction={'row'} spacing={1}>
                <Avatar user={{ first_name: 'Georgina', last_name: 'Watson' }} />
                <Text>Georgina Watson</Text>
            </Stack>
        ),
        uploaded_on: 'Apr 3 at 1:32pm',
        size: '512KB',
    },
    {
        name: 'Link name',
        type: 'Website Link',
        uploaded_by: (
            <Stack alignItems={'center'} direction={'row'} spacing={1}>
                <Avatar user={{ first_name: 'Georgina', last_name: 'Watson' }} />
                <Text>Georgina Watson</Text>
            </Stack>
        ),
        uploaded_on: 'Apr 3 at 1:34pm',
        size: '--',
    },
    {
        name: 'Filename.pdf',
        type: 'PDF',
        uploaded_by: (
            <Stack alignItems={'center'} direction={'row'} spacing={1}>
                <Avatar user={{ first_name: 'Georgina', last_name: 'Watson' }} />
                <Text>Georgina Watson</Text>
            </Stack>
        ),
        uploaded_on: 'Apr 3 at 3:52pm',
        size: '2MB',
    },
];

const ScrollableTableDemo = () => {
    return (
        <>
            <Text variant={'sh1'}>ScrollableTable</Text>
            <CustomScrollableTable>
                <ScrollableTableHead>
                    <ScrollableTableRow>
                        <CustomScrollableTableCell isFixed>
                            <Checkbox defaultChecked={false} />
                        </CustomScrollableTableCell>
                        <CustomScrollableTableCell isFixed>Name</CustomScrollableTableCell>
                        <CustomScrollableTableCell>Type</CustomScrollableTableCell>
                        <CustomScrollableTableCell>Uploaded By</CustomScrollableTableCell>
                        <CustomScrollableTableCell>Uploaded On</CustomScrollableTableCell>
                        <CustomScrollableTableCell>Size</CustomScrollableTableCell>
                        <CustomScrollableTableCell isFixed></CustomScrollableTableCell>
                    </ScrollableTableRow>
                </ScrollableTableHead>
                <ScrollableTableBody>
                    {data.map((row, index) => (
                        <ScrollableTableRow key={index}>
                            <CustomScrollableTableCell isFixed>
                                <Checkbox defaultChecked={false} />
                            </CustomScrollableTableCell>
                            <CustomScrollableTableCell isFixed>{row.name}</CustomScrollableTableCell>
                            <CustomScrollableTableCell>{row.type}</CustomScrollableTableCell>
                            <CustomScrollableTableCell>{row.uploaded_by}</CustomScrollableTableCell>
                            <CustomScrollableTableCell>{row.uploaded_on}</CustomScrollableTableCell>
                            <CustomScrollableTableCell>{row.size}</CustomScrollableTableCell>
                            <CustomScrollableTableCell isFixed>
                                <Stack direction={'row'} spacing={1}>
                                    <IconButton kind={'download'} size={'medium'} variant={'square'} />
                                    <IconButton kind={'delete'} size={'medium'} variant={'square'} />
                                </Stack>
                            </CustomScrollableTableCell>
                        </ScrollableTableRow>
                    ))}
                </ScrollableTableBody>
            </CustomScrollableTable>
        </>
    );
};

const CustomScrollableTable = styled(ScrollableTable)(() => {
    return {
        width: '500px',
        minHeight: '500px',
    };
});

const CustomScrollableTableCell = styled(ScrollableTableCell)(({ theme }) => {
    return {
        '&:nth-child(1)': {
            left: 0,
            width: '73px',
        },
        '&:nth-child(2)': {
            left: '73px',
            width: '100px',
            minWidth: '100px',
            maxWidth: '100px',
        },
        '&:last-child': {
            right: 0,
            borderLeft: `1px solid ${theme.palette.ensightful.neutral[300]}`,
            width: '100px',
        },
        '&:nth-last-child(2)': {
            borderRight: 'none',
        },
    };
});

export default ScrollableTableDemo;
